import { Tbody, Tr, Td } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import RowMenuCell from 'pages/Dashboard/CompanyOverview/CompanyTable/Body/RowMenuCell';
import { CompanyLead } from 'types';

const rowStyle = {
  backgroundColor: 'transparent',
  '&:hover': {
    cursor: 'pointer',
    td: {
      background: Colors.ArmyGreen100,
    },
  },
  td: {
    backgroundColor: Colors.White,
  },
};

type Props = {
  groupId: number;
  items: CompanyLead[];
  onRowClick?: (company: CompanyLead) => void;
  onRemoveFromGroup?: (company: CompanyLead) => void;
};

const TableBody = ({ groupId, items, onRowClick, onRemoveFromGroup }: Props) => {
  if (!items?.length) {
    return null;
  }

  return (
    <Tbody key={`company-table-body-${groupId}`}>
      {items.map((company) => (
        <Tr
          key={`company-id-${company.id}`}
          onClick={() => onRowClick?.(company)}
          sx={rowStyle}
        >
          <Td>
            <Text.BodyBold>{company.name}</Text.BodyBold>
          </Td>
          <Td>
            <Text>{company.num_active_projects}</Text>
          </Td>
          <Td onClick={(e) => e.stopPropagation()}>
            {onRemoveFromGroup && (
              <RowMenuCell company={company} onRemoveFromGroup={onRemoveFromGroup} />
            )}
          </Td>
        </Tr>
      ))}
    </Tbody>
  );
};

export default TableBody;
